import * as React from 'react';
import bindAllOfThis from "src/utils/BindThisHelper";
import PhaserGameComponent from 'src/games/shared/phaserHelpers/PhaserGameComponent';
import { GameIntroScene } from 'src/games/FitFiveGame/scenes/GameIntro';

interface PhaserFitFiveGameProps {
    onComplete: () => void;
}

interface PhaserFitFiveGameState {
}

const gameConfig: GameConfig = {
    title: "Fit Five Game",
    version: "0.9.3",
    backgroundColor: "#000000"
};

class PhaserFitFiveGame extends React.Component<PhaserFitFiveGameProps, PhaserFitFiveGameState> {
    private game: Phaser.Game;
    constructor(props: PhaserFitFiveGameProps) {
        super(props);
        bindAllOfThis(this, PhaserFitFiveGame.prototype);
    }

    render() {
        return (<div>
            <PhaserGameComponent scenes={GameIntroScene} config={gameConfig} onComplete={this.props.onComplete} />
        </div>);
    }
}

export default PhaserFitFiveGame;



// WEBPACK FOOTER //
// ./src/games/FitFiveGame/Main.tsx